import React, { useState } from "react"
import { connect } from "react-redux"
import { Tooltip } from "@material-ui/core"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearchLocation } from "@fortawesome/free-solid-svg-icons"

import { Formik } from "formik"
import { selectNewAreaDispatchAction } from "../../../state/geoMap/dispatchActions"
import {
  getSyncSearchFormValuesByState,
} from "../../../helpers/configurationHelper"
import { ConfigurationsType } from "../../../types/configurations"
import { ShapeType } from "../../../types/shape"
import { DEFAULT_TOOLTIP_PROPS } from "../../../helpers/tooltipHelper"
import translations from "../../../translations"
import TooltipLocation from "../../shared/TooltipLocation"
import {SearchResultsType} from "../../../types/product";

interface PropsType {
  configurations: ConfigurationsType,
  selectedArea: ShapeType,
  values: any,
  updatePathCoordinatesActionHandler: any,
  language: string,
  selectNewAreaDispatchActionHandler: any,
  searchByProducts: boolean,
  searchResults: SearchResultsType
}

const LocationOIHelper = (props: PropsType) => {
  const { language, searchByProducts, searchResults } = props

  const [showTooltip, setShowTooltip] = useState(false)
  const toggleTooltip = () => setShowTooltip((state) => !state)
  const handleCLose = () => setShowTooltip(false)
  const [key, setKey] = useState("bbox")

  return (
    <div className="path-importer-container">
      <Tooltip
        {...DEFAULT_TOOLTIP_PROPS}
        title={translations("locationTooltip", language)}
        placement="bottom"
      >
        <div>
          <FontAwesomeIcon
            className="path-file-importer-icon fa-lg"
            icon={faSearchLocation}
            onClick={(event) => {
              event.preventDefault()
              // event.stopPropagation();
              toggleTooltip()
            }}
          />
          {showTooltip && (
            <Formik
              initialValues={{
                where: "",
              }}
              onSubmit={() => {}}
            >
              {(formProps) => (
                <TooltipLocation
                  handleClose={handleCLose}
                  formProps={formProps}
                />
              )}
            </Formik>
          )}
        </div>
      </Tooltip>
    </div>
  )
}

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  language: state.application.appParameters.language,
  searchByProducts: state.geoMap.searchByProducts,
  searchResults: state.product.searchResults
})

const mapDispatchToProps = (dispatch) => ({
  selectNewAreaDispatchActionHandler: (
    configurations,
    appParameters,
    scopeFields,
    formValues,
    newShape,
    language,
    searchByProducts,
    searchResults
  ) => dispatch(
    selectNewAreaDispatchAction(
      configurations,
      appParameters,
      scopeFields,
      formValues,
      newShape,
      language,
      searchByProducts,
      searchResults
    )
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(LocationOIHelper)
